"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Content = _interopRequireDefault(require("@insided/deprecated-preact-components/common/Content"));

var _HubAI = require("@insided/shared/modules/HubAI");

var _PinnedReplyLabel = _interopRequireDefault(require("@insided/deprecated-preact-components/pinned-reply/PinnedReplyLabel"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _Reports = _interopRequireDefault(require("@insided/destination/modules/Content/TopicView/V2/Reports"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var PINNED_REPLY_COLOR = 'color-mix(in srgb, var(--config--main-color-brand) 5%, var(--config-card-background-color))';

var ReplyBody = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ReplyBody, _Component);

  var _super = _createSuper(ReplyBody);

  function ReplyBody() {
    var _this;

    (0, _classCallCheck2.default)(this, ReplyBody);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "programmaticallyScrollToReply", function () {
      var reply = _this.props.reply;
      var publicReplyId = reply.publicReplyId;
      var replyElementId = "post".concat(publicReplyId);
      var replyElement = document.getElementById(replyElementId);

      if (replyElement) {
        replyElement.scrollIntoView({
          behavior: 'smooth'
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "shouldScrollToReply", function () {
      var reply = _this.props.reply;
      var publicReplyId = reply.publicReplyId;
      var replyElementId = "post".concat(publicReplyId);
      var urlHash = window.location.hash;
      return urlHash === "#".concat(replyElementId);
    });
    return _this;
  }

  (0, _createClass2.default)(ReplyBody, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var isUserUsingFirefox, shouldScrollToReply;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isUserUsingFirefox = navigator.userAgent.includes('Mozilla');
                shouldScrollToReply = this.shouldScrollToReply();

                if (isUserUsingFirefox && shouldScrollToReply) {
                  this.programmaticallyScrollToReply();
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          isTranslationInProgress = _this$props.isTranslationInProgress,
          isAllRepliesTranslationInProgress = _this$props.isAllRepliesTranslationInProgress,
          languageList = _this$props.languageList,
          reply = _this$props.reply,
          parentTopicTitle = _this$props.parentTopicTitle,
          translatedReplyContent = _this$props.translatedReplyContent,
          showEditor = _this$props.showEditor,
          userSignature = _this$props.userSignature,
          editor = _this$props.editor,
          attachments = _this$props.attachments;
      var replyContent = reply.content,
          isPinnedReply = reply.isPinnedReply,
          isBestAnswer = reply.isBestAnswer,
          highlighted = reply.highlighted,
          trashed = reply.trashed,
          spam = reply.spam,
          reported = reply.reported,
          _reply$reportedConten = reply.reportedContent,
          reportedContent = _reply$reportedConten === void 0 ? [] : _reply$reportedConten;
      var initialContent = {
        title: parentTopicTitle,
        topicContent: null,
        bestAnswerText: null,
        pinnedReplyText: null,
        replies: [],
        individualReply: replyContent
      };
      return (0, _preact.h)(_HubAI.OnDemandTranslationProvider, {
        initialContent: initialContent,
        languageList: languageList,
        shouldTranslateOnlyOneReply: true
      }, (0, _preact.h)("div", {
        className: "post, qa-topic-post-box"
      }, (0, _preact.h)(_HubAI.OnDemandTranslationContext.Consumer, null, function (_ref) {
        var _ref2;

        var isTranslationInProgressForReply = _ref.isTranslationInProgressForReply,
            isPostTranslatedForReply = _ref.isPostTranslatedForReply,
            translatedReply = _ref.translatedReply;

        if (isTranslationInProgressForReply) {
          _this2.programmaticallyScrollToReply();
        }

        return (0, _preact.h)("div", {
          className: (0, _classnames.default)('threaded-reply-body-wrapper', {
            'translation-loading': (_ref2 = isTranslationInProgress !== null && isTranslationInProgress !== void 0 ? isTranslationInProgress : isTranslationInProgressForReply) !== null && _ref2 !== void 0 ? _ref2 : isAllRepliesTranslationInProgress,
            'post--pinned': isPinnedReply,
            'best-answer': isBestAnswer,
            'with-attachments': !!attachments,
            'post--modbreak': highlighted,
            'post--trashed': trashed,
            'post--spam': spam,
            'post--reported': reported
          }),
          style: isPinnedReply ? {
            backgroundColor: PINNED_REPLY_COLOR
          } : undefined
        }, showEditor ? editor : (0, _preact.h)("div", {
          className: "topic-view-content-wrapper"
        }, isPinnedReply && (0, _preact.h)("div", {
          className: "pinned-reply__label--comments"
        }, (0, _preact.h)(_PinnedReplyLabel.default, {
          phrase: (0, _preact.h)(_phrase.default, {
            p: "reply.pinned",
            m: "Forum"
          })
        })), (0, _preact.h)(_Content.default, {
          content: isPostTranslatedForReply ? translatedReply : translatedReplyContent || replyContent
        }), reportedContent.length > 0 && (0, _preact.h)(_Reports.default, {
          reportedContent: reportedContent
        }), (0, _preact.h)(_HubAI.OnDemandTranslationButton, null)), userSignature, attachments);
      })));
    }
  }]);
  return ReplyBody;
}(_preact.Component);

var _default = ReplyBody;
exports.default = _default;